import React, { useRef, useState } from 'react';
import { IonButton, IonButtons, IonIcon, IonModal, IonPicker, IonPickerColumn, IonPickerColumnOption, IonTitle, IonToolbar } from '@ionic/react';
import { chevronDown } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';

interface YearPickerProps {
  defaultValue?: string | number;
  onChange?: (value: string) => void;
  className?: string;
  placeholder?: string;
  startYear?: number;
  endYear?: number;
}

const YearPicker: React.FC<YearPickerProps> = ({
  defaultValue,
  onChange = () => { },
  className,
  placeholder = 'Select Year',
  startYear = 1900,
  endYear = new Date().getFullYear(),
}) => {
  const [showModal, setShowModal] = useState(false);
  const modal = useRef<HTMLIonModalElement>(null);
  const { t } = useTranslation();

  // Current selected year
  const [selectedYear, setSelectedYear] = useState<string>(defaultValue ? String(defaultValue) : '');

  const handleSelect = (value: string) => {
    onChange(value);
    setShowModal(false);
  };

  return (
    <>
      <IonButton
        fill='clear'
        color='transparent'
        onClick={() => setShowModal(true)}
        className={`w-full h-12 max-w-xs text-foreground border-input border rounded-md ${className}`}
      >
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-4">
            {defaultValue ? (
              <span>{defaultValue}</span>
            ) : (
              <span className="text-muted-foreground">{placeholder}</span>
            )}
          </div>
          <IonIcon icon={chevronDown} className="size-5" />
        </div>
      </IonButton>

      <IonModal
        ref={modal}
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        className="auto-height"
      >
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => setShowModal(false)}>
              {t('cancel')}
            </IonButton>
          </IonButtons>
          <IonButtons slot="end">
            <IonButton onClick={() => {
              if (selectedYear) {
                handleSelect(selectedYear);
              }
            }}>
              {t('done')}
            </IonButton>
          </IonButtons>
        </IonToolbar>

        <div className="picker-wrapper flex-1 overflow-hidden flex items-center justify-center">
          <IonPicker className="w-full h-full">
            <IonPickerColumn value={selectedYear} onIonChange={({ detail }) => {
              if (detail.value !== undefined) {
                setSelectedYear(String(detail.value));
              }
            }}>
              <IonPickerColumnOption value="" disabled={true}>
                {t('select_year') || 'Select Year'}
              </IonPickerColumnOption>
              {Array.from({ length: endYear - startYear + 1 }, (_, i) => {
                const year = String(endYear - i);
                return (
                  <IonPickerColumnOption key={year} value={year}>
                    {year}
                  </IonPickerColumnOption>
                );
              })}
            </IonPickerColumn>
          </IonPicker>
        </div>
      </IonModal>
    </>
  );
};

export default YearPicker;
